import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { axiosbaseurl } from "configure"
import moment from "moment"
import swal from "sweetalert"

const ClientEmailFilesModal = ({ show, setShow, client }) => {
  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(false)
  const [showUpload, setShowUpload] = useState(false)

  const [showPreview, setShowPreview] = useState(false)
  const [previewLoading, setPreviewLoading] = useState(null)
  const [previewData, setPreviewData] = useState(null)

  useEffect(() => {
    if (show && client?.id) {
      fetchFiles()
    }
  }, [show, client?.id])

  useEffect(() => {
    if (!showUpload) {
    }
  }, [showUpload])

  useEffect(() => {
    if (!show) {
      setFiles([])
      setShowUpload(false)
      setShowPreview(false)
      setPreviewData(null)
    }
  }, [show])

  const fetchFiles = async () => {
    try {
      setLoading(true)
      const { data } = await axiosbaseurl.get(
        `/client-email/client/${client.id}`
      )
      if (data.success) setFiles(data.data || [])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handlePreview = async item => {
    try {
      setPreviewLoading(item.id)
      const url = `${process.env.REACT_APP_IMAGE_PATH}/${item.file}`
      const response = await fetch(url)
      const buffer = await response.arrayBuffer()
      const ext = item.filename?.split(".").pop()?.toLowerCase()

      let parsed = {}

      if (ext === "eml") {
        const PostalMime = (await import("postal-mime")).default
        const parser = new PostalMime()
        const email = await parser.parse(buffer)
        parsed = {
          subject: email.subject || "--",
          from: email.from?.text || email.from?.address || "--",
          to: email.to?.map(t => t.text || t.address).join(", ") || "--",
          cc: email.cc?.map(t => t.text || t.address).join(", ") || "",
          date: email.date
            ? moment(email.date).format("DD-MM-YYYY | hh:mm A")
            : "--",
          body:
            email.html ||
            (email.text
              ? `<pre style="white-space:pre-wrap;font-family:inherit">${email.text}</pre>`
              : "<p>No content</p>"),
          attachments:
            email.attachments?.map(a => ({
              name: a.filename,
              size: a.size,
            })) || [],
        }
      } else if (ext === "msg") {
        const MsgReaderModule = await import("@kenjiuno/msgreader")
        const MsgReader = MsgReaderModule.default || MsgReaderModule

        const reader = new MsgReader(buffer)
        const fileData = reader.getFileData()

        let bodyContent =
          fileData.bodyHtml || fileData.htmlBody || fileData.body || ""

        if (!bodyContent) {
          bodyContent = "<p>No content found in MSG file</p>"
        } else if (!bodyContent.trim().startsWith("<")) {
          bodyContent = `<pre style="white-space:pre-wrap;font-family:inherit">${bodyContent}</pre>`
        }

        parsed = {
          subject: fileData.subject || "--",
          from: fileData.senderName
            ? `${fileData.senderName}${
                fileData.senderEmail ? ` <${fileData.senderEmail}>` : ""
              }`
            : fileData.senderEmail || "--",
          to:
            fileData.recipients?.map(r => r.name || r.email).join(", ") || "--",
          cc: "",
          date: fileData.messageDeliveryTime
            ? moment(fileData.messageDeliveryTime).format(
                "DD-MM-YYYY | hh:mm A"
              )
            : "--",
          body: bodyContent,
          attachments:
            fileData.attachments?.map(a => ({
              name: a.fileName || a.filename || "attachment",
            })) || [],
        }
      }

      setPreviewData(parsed)
      setShowPreview(true)
    } catch (error) {
      console.log(error)
      swal("", "Failed to preview file", "error")
    } finally {
      setPreviewLoading(null)
    }
  }

  return (
    <>
      {/* Files List Modal */}
      <Modal
        size="xl"
        isOpen={show}
        toggle={() => setShow(false)}
        centered={true}
      >
        <div className="modal-content">
          <ModalHeader className="bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-2">
              <h5 className="mb-0 text-white">
                Emails
                {client?.clientName ? (
                  <span className="fw-normal"> — {client.clientName}</span>
                ) : null}
              </h5>
              <div>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => setShow(false)}
                >
                  <i className="fa fa-times me-2"></i>Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {loading ? (
              <div className="text-center py-5">
                <i className="bx bx-loader bx-spin fs-3 text-primary"></i>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th>#</th>
                      <th>File Name</th>
                      <th>Task</th>
                      <th>Service</th>
                      <th>Label</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {files.map((item, i) => (
                      <tr key={item.id}>
                        <td>{i + 1}</td>
                        <td>{item?.filename || "--"}</td>
                        <td>{item?.task?.title || "--"}</td>
                        <td>{item?.service?.serviceName || "--"}</td>
                        <td>{item?.label || "--"}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-primary me-2"
                            title="Preview"
                            disabled={previewLoading === item.id}
                            onClick={() => handlePreview(item)}
                          >
                            <i
                              className={
                                previewLoading === item.id
                                  ? "bx bx-loader bx-spin"
                                  : "fas fa-eye"
                              }
                            ></i>
                          </button>
                          <a
                            href={`${process.env.REACT_APP_IMAGE_PATH}/${item.file}`}
                            target="_blank"
                            rel="noreferrer"
                            download
                            className="btn btn-sm btn-dark me-2"
                            title="Download"
                          >
                            <i className="fas fa-download"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                    {!files.length && (
                      <tr>
                        <td
                          colSpan={6}
                          className="text-center text-danger py-3"
                        >
                          No email files uploaded yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
        </div>
      </Modal>

      {/* Preview Modal */}
      <Modal
        size="xl"
        isOpen={showPreview}
        toggle={() => setShowPreview(false)}
        centered={true}
      >
        <div className="modal-content">
          <ModalHeader className="bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-2">
              <h5 className="mb-0 text-white">Email Preview</h5>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={() => setShowPreview(false)}
              >
                <i className="fa fa-times me-2"></i>Close
              </button>
            </div>
          </ModalHeader>
          <ModalBody className="px-4 py-3">
            {previewData && (
              <div>
                <table className="table table-bordered mb-4">
                  <tbody>
                    <tr>
                      <th style={{ width: "100px" }} className="table-light">
                        Subject
                      </th>
                      <td>{previewData.subject}</td>
                    </tr>
                    <tr>
                      <th className="table-light">From</th>
                      <td>{previewData.from}</td>
                    </tr>
                    <tr>
                      <th className="table-light">To</th>
                      <td>{previewData.to}</td>
                    </tr>
                    {previewData.cc && (
                      <tr>
                        <th className="table-light">CC</th>
                        <td>{previewData.cc}</td>
                      </tr>
                    )}
                    <tr>
                      <th className="table-light">Date</th>
                      <td>{previewData.date}</td>
                    </tr>
                  </tbody>
                </table>

                <div
                  className="border rounded p-3 bg-light mb-4"
                  style={{
                    minHeight: "200px",
                    maxHeight: "500px",
                    overflowY: "auto",
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: previewData.body }} />
                </div>

                {previewData.attachments.length > 0 && (
                  <div>
                    <h6 className="fw-semibold mb-2">
                      <i className="fas fa-paperclip me-2"></i>
                      Attachments ({previewData.attachments.length})
                    </h6>
                    <div className="d-flex flex-wrap gap-2">
                      {previewData.attachments.map((att, i) => (
                        <span
                          key={i}
                          className="badge bg-secondary py-2 px-3 fs-6"
                        >
                          <i className="fas fa-file me-2"></i>
                          {att.name}
                          {att.size
                            ? ` (${(att.size / 1024).toFixed(1)} KB)`
                            : ""}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

export default ClientEmailFilesModal
